import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CreateVendorCategorySlice } from '../../../../redux/features/VendorCategoryManagementSlice';
import ButtonSpinner from '../../../../common/Loader/ButtonSpinner';
import { useSelector } from 'react-redux';

const AddVendorCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const AnchorRef = useRef(null);
  const { loading } = useSelector((state) => state.VendorCategoryManagement);

  const [data, setData] = useState({
    categoryName: '',
    description: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (!data.categoryName?.trim()?.length) {
      toast.error('Please fill category name!');
      return;
    }

    dispatch(CreateVendorCategorySlice(data)).then((res) => {
      if (res?.payload?.data) {
        AnchorRef.current.click();
      }
    });
  };

  const handleNavigate = () => {
    navigate(-1);
  };

  return (
    <div className="ModalBox">
      <div id="AddVendorCategory" className="modal fade" data-backdrop="static" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="Category">
                <a
                  ref={AnchorRef}
                  href="javascript:void(0);"
                  className="CloseModal"
                  data-dismiss="modal"
                  onClick={handleNavigate}
                >
                  ×
                </a>
                <h3>Create Vendor Category</h3>
                <div className="form-group">
                  <label>Category Name</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="e.g. Catering, Photography, Decoration"
                    name="categoryName"
                    value={data.categoryName}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Description</label>
                  <textarea
                    className="form-control"
                    placeholder="Short description of this category"
                    rows={3}
                    name="description"
                    value={data.description}
                    onChange={handleChange}
                  />
                </div>
                <button disabled={loading} onClick={handleSubmit} className="Button">
                  {loading ? <ButtonSpinner /> : 'Add'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddVendorCategory;
